<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="菜品详情"
      width="80%"
      @close="close"
    >
      <el-row>
        <el-col :span="5">菜品名称:</el-col>
        <el-col :span="19">{{ showForm.title }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">菜品封面:</el-col>
        <el-col :span="19">
          <el-image
            :src="showForm.basic && showForm.basic.avatar"
            class="p-avatar"
          >
            <template v-slot:error class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </template>
          </el-image>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">菜品轮播图:</el-col>
        <el-col :span="12">
          <el-carousel :interval="4000" height="160px" class="e-carousel">
            <el-carousel-item
              v-for="item in showForm.basic.imageList || []"
              :key="item.name"
            >
              <el-image :src="item.url" fit="scale-down"></el-image>
            </el-carousel-item>
          </el-carousel>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">价格:</el-col>
        <el-col :span="20">
          {{showForm.basic && showForm.basic.price&&showForm.basic.price.defaultPrice}}/{{showForm.basic && showForm.basic.unit}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          日库存:{{ showForm.basic.stock && showForm.basic.stock.dailyStock }}
        </el-col>
        <el-col :span="12">
          总库存:{{ showForm.basic.stock && showForm.basic.stock.totalStock }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">说明:</el-col>
        <el-col :span="15">
          <div
            class="rich-box"
            v-html="showForm.basic && showForm.basic.text"
          ></div>
        </el-col>
      </el-row>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { findDish } from '@/api/food'
export default {
  name: 'DishDetail',
  emits: ['fetch-data'],
  data() {
    return {
      showForm: {},
      dialogFormVisible: false,
    }
  },
  methods: {
    async show(row) {
      const dishId = row.dishId
      const data = await findDish({
        dishId,
      })
      this.showForm = data
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
